<template>
  <div>
    <h6>
      Formulär
    </h6>
    <b-form>
      <b-form-group
        id="fieldset-52"
        label="Give your survey a name"
        label-for="input-52"
      >
        <b-form-input placeholder="Survey name" id="input-52" v-model="test" trim required></b-form-input>
      </b-form-group>
      <b-form-group v-slot="{ ariaDescribedby }" label="Select option">
        <b-form-radio v-model="surveyType" :aria-describedby="ariaDescribedby" name="survey-type" value="1">GDQ</b-form-radio>
        <b-form-radio v-model="surveyType" :aria-describedby="ariaDescribedby" name="survey-type" value="2">GDQ Short</b-form-radio>
        <b-form-radio v-model="surveyType" :aria-describedby="ariaDescribedby" name="survey-type" value="3">OSC</b-form-radio>
        <div class="text-md">Please select the type of survey to create</div>
      </b-form-group>
    </b-form>
    <h6>
      Inmatningsfält
    </h6>
    <b-form>
      <b-form-group
        id="fieldset-1"
        label="A required input field"
        label-for="input-1"
      >
        <b-form-input placeholder="Placeholder here" id="input-1" v-model="test" trim required></b-form-input>
      </b-form-group>

      <b-form-group
        id="fieldset-2"
        label="A valid input field"
        label-for="input-2"
      >
        <b-form-input class="is-valid" id="input-2" v-model="test2" trim></b-form-input>
      </b-form-group>

      <b-form-group
        id="fieldset-3"
        label="An invalid input field"
        label-for="input-3"
        :invalid-feedback="invalidFeedback"
        :state="state"
      >
        <b-form-input placeholder="Your name" id="input-3" v-model="name" :state="state" trim></b-form-input>
      </b-form-group>

      <b-form-group
        class="survey"
        id="fieldset-4"
        label="Survey input field"
        label-for="input-4"
      >
        <b-form-input placeholder="Test Survey" id="input-4" v-model="test3" trim></b-form-input>
      </b-form-group>

      <h6>
        Dropdown
      </h6>

      <b-form-group>
        <b-form-select v-model="selectedOption" class="mb-3">
          <b-form-select-option value="a">Option A</b-form-select-option>
          <b-form-select-option value="b" disabled>Option B (disabled)</b-form-select-option>
          <b-form-select-option :value="{ C: '3PO' }">Option with object value</b-form-select-option>
          <b-form-select-option :value="{ R: '2D2' }">Another option with object value</b-form-select-option>
        </b-form-select>
      </b-form-group>

      <h6>
        Radio
      </h6>

      <b-form-group v-slot="{ ariaDescribedby }" label="Select option">
        <b-form-radio v-model="selectedRadio" :aria-describedby="ariaDescribedby" name="some-radios" value="A">Option A</b-form-radio>
        <b-form-radio v-model="selectedRadio" :aria-describedby="ariaDescribedby" name="some-radios" value="B">Option B</b-form-radio>
      </b-form-group>

      <b-form-group v-slot="{ ariaDescribedby }" label="Select another option">
        <b-form-radio v-model="selectedRadio2" :aria-describedby="ariaDescribedby" name="some-radios2" value="C">Option C</b-form-radio>
        <b-form-radio v-model="selectedRadio2" :aria-describedby="ariaDescribedby" name="some-radios2" value="D">Option D</b-form-radio>
      </b-form-group>

      <h6>
        Checkbox
      </h6>

      <b-form-group
        v-slot="{ ariaDescribedby }"
        label="Choose a fruit"
      >
        <b-form-checkbox-group
          v-model="selectedCheckbox"
          :options="checkOptions"
          :aria-describedby="ariaDescribedby"
          name="flavour-2a"
          stacked
        ></b-form-checkbox-group>
      </b-form-group>

      <b-form-group
        v-slot="{ ariaDescribedby }"
        label="Choose a vegetable"
      >
        <b-form-checkbox-group
          v-model="selectedCheckbox2"
          :options="checkOptions2"
          :aria-describedby="ariaDescribedby"
          name="flavour-2b"
          stacked
        ></b-form-checkbox-group>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
export default {
  computed: {
    state () {
      return this.name.length >= 4
    },
    invalidFeedback () {
      if (this.name.length < 4) {
        return 'Name must be at least 4 letters'
      }
    }
  },
  data () {
    return {
      test: '',
      test2: 'This field is validated',
      test3: '',
      name: '',
      selectedRadio: 'B',
      selectedRadio2: 'C',
      selectedOption: 'a',
      selectedCheckbox: ['apple'],
      selectedCheckbox2: ['broccoli'],
      checkOptions: [
        { text: 'Orange', value: 'orange' },
        { text: 'Apple', value: 'apple' },
        { text: 'Pineapple', value: 'pineapple' },
        { text: 'Grape', value: 'grape' }
      ],
      checkOptions2: [
        { text: 'Cucumber', value: 'cucumber' },
        { text: 'Tomato', value: 'tomato' },
        { text: 'Onion', value: 'onion' },
        { text: 'Broccoli', value: 'broccoli' }
      ]
    }
  }
}
</script>
